var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSaudiArabia(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_7275)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256 512C397.385 512 512 397.385 512 256C512 114.615 397.385 0 256 0C114.615 0 0 114.615 0 256C0 397.385 114.615 512 256 512Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.696 306.087C144.696 324.528 159.646 339.478 178.087 339.478H278.261C278.261 354.846 290.719 367.304 306.087 367.304H339.478C354.846 367.304 367.304 354.846 367.304 339.478V306.087H144.696Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.087 144.696V222.609C370.087 234.884 360.101 244.87 347.826 244.87V278.261C378.513 278.261 403.478 253.295 403.478 222.609V144.696H370.087Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.783 222.609C130.783 234.884 120.797 244.87 108.522 244.87V278.261C139.209 278.261 164.174 253.295 164.174 222.609V144.696H130.783V222.609Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320 144.696H353.391V222.609H320V144.696Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.913 189.217C269.913 192.286 267.416 194.782 264.348 194.782C261.28 194.782 258.783 192.285 258.783 189.217V144.695H225.392V189.217C225.392 192.286 222.895 194.782 219.827 194.782C216.759 194.782 214.262 192.285 214.262 189.217V144.695H180.87V189.217C180.87 210.698 198.346 228.174 219.827 228.174C228.1 228.174 235.772 225.574 242.088 221.158C248.403 225.573 256.076 228.174 264.349 228.174C266.015 228.174 267.653 228.057 269.264 227.852C266.898 237.601 258.118 244.869 247.653 244.869V278.26C278.34 278.26 303.305 253.294 303.305 222.608V189.217V144.695H269.914V189.217H269.913Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.87 244.87H230.957V278.261H180.87V244.87Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_7275"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaudiArabia);
export default __webpack_public_path__ + "static/media/saudiArabia.2854c6a9271df1c6099172bd5ace0541.svg";
export { ForwardRef as ReactComponent };